import { Link } from 'react-router-dom'
import { Button, Divider, SectionTitle } from '@du/ui'
import type { Loja } from '../lib/api.js'

/**
 * Política de privacidade. Curta e em português de gente, porque política que
 * ninguém lê não informa ninguém — e a LGPD pede informação clara, não jurídiquês.
 */
export function Privacidade({ loja }: { loja: Loja | null }) {
  return (
    <article className="bloco legal">
      <SectionTitle variante="preto">Privacidade</SectionTitle>

      <h3>O que guardamos</h3>
      <p>
        Seu <strong>nome</strong>, <strong>telefone</strong> e, quando o pedido é entrega, o{' '}
        <strong>endereço</strong>. É o mínimo para preparar e levar o lanche até você.
      </p>

      <h3>Para que usamos</h3>
      <p>
        Para produzir seu pedido, entregá-lo e avisar quando ele sair. O telefone também serve para
        reconhecer você em um próximo pedido, sem precisar digitar tudo de novo.
      </p>

      <h3>O que NÃO fazemos</h3>
      <ul>
        <li>Não vendemos nem compartilhamos seus dados com terceiros.</li>
        <li>Não guardamos dados de cartão — o pagamento é na entrega ou por Pix.</li>
        <li>Não usamos cookie de rastreio para publicidade.</li>
        <li>
          Quando você entra na sua conta pelo link de um pedido, a gente guarda um cookie só
          para manter você conectado. Ele é necessário para essa função e não serve para
          publicidade.
        </li>
        <li>
          A entrada na sua conta é pelo link do seu pedido. Lá você vê seus pontos, seus
          pedidos anteriores e pode pedir de novo. Quem tiver esse link consegue ver essas
          informações, então guarde ele como você guardaria uma senha.
        </li>
      </ul>

      <h3>Por quanto tempo</h3>
      <p>
        O histórico de pedidos fica guardado enquanto você for cliente, porque é dele que sai o
        controle de vendas da loja. Você pode pedir a exclusão a qualquer momento.
      </p>

      <h3>Seus direitos</h3>
      <p>
        Você pode pedir para ver, corrigir ou apagar seus dados. É só chamar no WhatsApp
        {loja ? ` ${loja.whatsapp}` : ''} ou falar com a gente na loja.
      </p>

      <Divider />
      <p className="legal__rodape">
        {loja ? `${loja.nome} · ${loja.endereco.rua}, ${loja.endereco.numero} — ${loja.endereco.bairro}, ${loja.endereco.cidade}/${loja.endereco.uf}` : null}
      </p>
      <Link to="/">
        <Button variante="secundario">Voltar ao cardápio</Button>
      </Link>
    </article>
  )
}
